import type { EngineStatus } from "@gmx/shared";
import { Badge, Tooltip } from "@gmx/ui";
import { engineState, formatDateTime, relativeTime } from "../lib/format";

/** Running / Paused until … / Idle / Not reporting, from IgAccount.engineStatus. */
export function EngineBadge({ status, size = "md" }: { status: EngineStatus | null | undefined; size?: "sm" | "md" }) {
  const st = engineState(status);
  if (st === "running")
    return (
      <Badge tone="success" dot size={size}>
        Automations running
      </Badge>
    );
  if (st === "paused") {
    const badge = (
      <Badge tone="warn" dot size={size} tabIndex={0}>
        Paused until {formatDateTime(status?.pausedUntil)}
      </Badge>
    );
    return status?.pauseReason ? <Tooltip content={status.pauseReason}>{badge}</Tooltip> : badge;
  }
  if (st === "idle")
    return (
      <Badge tone="neutral" dot size={size}>
        Idle
      </Badge>
    );
  return (
    <Badge tone="neutral" size={size}>
      Not reporting yet
    </Badge>
  );
}

/** One line of plain English about the engine, for cards. */
export function engineSentence(status: EngineStatus | null | undefined): string {
  const st = engineState(status);
  if (st === "running") return `The extension checked in ${relativeTime(status?.updatedAt)} and is working through your automations.`;
  if (st === "paused")
    return `X pushed back, so everything is paused until ${formatDateTime(status?.pausedUntil)}.${status?.pauseReason ? ` Reason: ${status.pauseReason}.` : ""} It resumes on its own.`;
  if (st === "idle") return `The extension checked in ${relativeTime(status?.updatedAt)}. Nothing is running right now.`;
  return "The extension hasn't reported on this account yet. Keep X open in a tab with the extension installed.";
}
